import gql from 'graphql-tag';

export const getCustomers = gql`
  query ($application: Int) {
    getCustomers(application: $application) {
      customerId
		  identifier
		  phone
		  email
		  remark
    }
  }
`
